import { EndpointSetting } from "@/lib/redux/type";
import { StoreState } from "../type";

export const callbackGetCategoryList: EndpointSetting['caller'] = (
  state: StoreState,
  action: any,
  endpointName: any
) => {
  state.category_list.loading = false
  state.category_list.called = true
  state.category_list.error = null
  state.category_list.success = true
  state.category_list.data = action.payload.results
  state.category_list.filter = {
    page: action.payload.page,
    page_size: action.payload.page_size,
    total_length: action.payload.total_length,
  }
}